import React from 'react'
import styled from 'styled-components'
import { scaleLinear, scaleSqrt } from 'd3-scale'

type Props = {
  completionPercentage: number
  size?: 'small' | 'medium'
  color?: string
  backgroundColor?: string
  scaling?: 'linear' | 'sqrt'
}

const BarOuter = styled.div<{ $height: number; $bg: string }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  border-radius: 9999px;
  height: ${({ $height }) => $height}px;
  background: ${({ $bg }) => $bg};
`

const BarInner = styled.div<{ $height: number; $color: string; $width: number }>`
  height: ${({ $height }) => $height}px;
  border-radius: 9999px;
  width: ${({ $width }) => $width}%;
  background: ${({ $color }) => $color};
  transition: width 0.5s ease-in-out;
`

export const ProgressBar: React.FC<Props> = (props) => {
  const scalingFunction = props.scaling === 'sqrt' ? scaleSqrt() : scaleLinear()
  const progress = scalingFunction.domain([0, 1]).range([2, 100])(props.completionPercentage)

  const height = props.size === 'medium' ? 12 : 4
  const color = props.color ?? '#000'
  const backgroundColor = props.backgroundColor ?? '#f6f2ec'
  return (
    <BarOuter $height={height} $bg={backgroundColor}>
      <BarInner $height={height} $color={color} $width={progress} />
    </BarOuter>
  )
}
